import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
// import {
  
// } from './reducer'

const reducer = {
  // User

}

// const userInfoFromStorage = localStorage.getItem('userInfo')
//   ? JSON.parse(localStorage.getItem('userInfo'))
//   : null

// const preLoadedState = {
//   userLogin: { userInfo: userInfoFromStorage },
// }


const store = configureStore({
  reducer,
})

export default store